const SITE_URL = 'https://dihaw.co'

export const SITE_LOGO_URL = `${SITE_URL}/favicon-blue.png`
export const DEFAULT_SEO_IMAGE_URL = `${SITE_URL}/assets/meta1.png`

const META_IMAGE_DIMENSIONS = [
  [1731, 909],
  [1733, 907],
  [1731, 909],
  [1731, 908],
  [1733, 907],
  [1733, 907],
  [1730, 909],
  [1734, 907],
] as const

export function getPageSeoImageUrl(path: string) {
  const url = new URL(path, SITE_URL)
  const pathname = url.pathname.replace(/\/+$/, '') || '/'
  const section = pathname.split('/')[1]
  let image = 1

  if (['jual', 'sewa', 'properti-baru', 'perumahan-baru'].includes(section)) image = 2
  else if (pathname === '/tentang-kami') image = 3
  else if (section === 'artikel') image = 4
  else if (pathname === '/partner') image = 5
  else if (section === 'agent') image = 6
  else if (section === 'pasang-property') image = url.searchParams.get('listingType') === 'rent' ? 8 : 7

  return `${SITE_URL}/assets/meta${image}.png`
}

export function getSeoImageDimensions(imageUrl: string) {
  const index = META_IMAGE_DIMENSIONS.findIndex((_, i) => imageUrl === `${SITE_URL}/assets/meta${i + 1}.png`)
  const dimensions = META_IMAGE_DIMENSIONS[index]
  return dimensions ? { width: dimensions[0], height: dimensions[1] } : undefined
}
